// extracted by mini-css-extract-plugin
export default {"row":"l1ARU2F"};